const initStat = null;

const profileReducer = (state = initStat, action) => {
  switch (action.type) {
    case "PROFILE_SET":
      return action.payload;

    case "PROFILE_UPDATE":
      return { ...state, ...action.payload };

    case "PROFILE_CLEAR":
      return initStat;

    default:
      return state;
  }
};

export default profileReducer;
